// import axios from "axios"
//
// export const client = axios.create();

import { ALLOWED_EM_DOMAINS} from './constants';
import DOMPurify from 'dompurify';

export function getEnv(applicationId) {
  return applicationId.replace('next_level_hr_', '').toLowerCase();
}

// export const getAppConfig = () => {
//   return client
//     .get(`/config.json`)
//     .then((res) => res.data)
//     .catch(console.log);
// };

// export function reSetUrl(url) {
//   const parsedUrl = new URL(url);
//   if (isAllowedDomain(parsedUrl.hostname)) {
//     window.location.replace(parsedUrl);
//   }
// }


export function isAllowedDomain(hostname, domainList) {
  return domainList.some(domain => hostname.endsWith(domain));
}

export function getEMDomain(currentHost) {
  // check if current host is start dev, test, or prod
  switch (currentHost) {
    case 'qa.pwc.com':
      return 'test.supportcentral.pwc.com';
    case 'nextlevelhr.pwc.com':
      return 'supportcentral.pwc.com';
    default:
      return 'dev.supportcentral.pwc.com';
  }
}



export function sanitizeUrl(url) {  
  const parser = document.createElement('a');  
  parser.href = url;  
  // Allow only http and https protocols and check the domain  
  if (['http:', 'https:'].includes(parser.protocol) && url && ALLOWED_EM_DOMAINS.some(d => url.startsWith(d))) {  
    return DOMPurify.sanitize(url, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] });;  
  }  
    
  return ''; // Return an empty string if the URL is not trusted  
} 

